import Divider from "components/common/Divider";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import {
  Button,
  Col,
  Form,
  FormControl,
  InputGroup,
  Row,
} from "react-bootstrap";
import { Link } from "react-router-dom";
import { Bounce, toast } from "react-toastify";
import SocialAuthButtons from "./SocialAuthButtons";
import { useNavigate } from "react-router-dom";
import ReCAPTCHA from "react-google-recaptcha";
import { validateEmail } from "utils/Validations";
import { useAppContext } from "Main";
import "./css/captcha.css";
import { customSettings } from "utils/customConfig";
import { CONSTANT_ROUTES } from "routes";

import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import SignUp from "./simple/SignUp";
import { SignUpAPI } from "api";
const RegistrationForm = ({ hasLabel, layout }) => {
  const { login, state } = useAppContext();
  const navigate = useNavigate();

  const [captcha, setCaptcha] = useState();

  const [error, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    firstName: "",
    emailAddress: "",
    mobileNumber: "",
    lastName: "",
    address: "",
    city: "",
    state: "",
    postalCode: "",
    country: "",
    avatar: "",
  });

  const handleFieldChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  // Validation
  const validateForm = () => {
    const validations = {};
    if (!formData.firstName.trim())
      validations.firstName = "Full name is required.";
    if (!validateEmail(formData.emailAddress))
      validations.emailAddress = "Valid email required.";
    if (!formData.mobileNumber.trim())
      validations.mobileNumber = "Phone number is required.";

    setErrors(validations);
    return Object.keys(validations).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    try {
      setLoading(true);
      await SignUpAPI.post(formData); // assuming your app context has signup(email, password, etc.)
      toast.success("Account created successfully!", {
        autoClose: customSettings.toastClose,
        position: customSettings.toastPosition,
      });
      navigate(CONSTANT_ROUTES.AUTHENTICATION_LOGIN);
    } catch (err) {
      console.error(err);
      toast.error("Signup failed! Please try again.", {
        autoClose: customSettings.toastClose,
        position: customSettings.toastPosition,
      });
    } finally {
      setLoading(false);
    }
  };

  const [showPass, setShowPass] = useState(false);
  const clickHandler = () => {
    setShowPass((prev) => !prev);
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Form.Group className="mb-3 ">
        {hasLabel && <Form.Label>Full Name</Form.Label>}
        <Form.Control
          placeholder={!hasLabel ? "Full Name" : ""}
          value={formData.firstName}
          name="firstName"
          autoFocus
          onChange={handleFieldChange}
          type="text"
          className={`${error.firstName && "border border-danger"}`}
        />
        <div className="text-danger text-xs">{error.firstName}</div>
      </Form.Group>
      <Form.Group className="mb-3 ">
        {hasLabel && <Form.Label>Email Address</Form.Label>}
        <Form.Control
          placeholder={!hasLabel ? "Email Address" : ""}
          value={formData.emailAddress}
          name="emailAddress"
          onChange={handleFieldChange}
          type="email"
          className={`${error.emailAddress && "border border-danger"}`}
        />
        <div className="text-danger text-xs">{error.emailAddress}</div>
      </Form.Group>
      <Form.Group className="mb-3 ">
        {hasLabel && <Form.Label>Phone Number</Form.Label>}
        <Form.Control
          placeholder={!hasLabel ? "Phone Number" : ""}
          value={formData.mobileNumber}
          name="mobileNumber"
          onChange={handleFieldChange}
          type="text"
          className={`${error.mobileNumber && "border border-danger"}`}
        />
        <div className="text-danger text-xs">{error.mobileNumber}</div>
      </Form.Group>

      {/* <InputGroup className="mb-3">
        <FormControl
          placeholder={!hasLabel ? "Password" : ""}
          value={formData.password}
          name="password"
          onChange={handleFieldChange}
          type={showPass ? "text" : "password"}
        />
        <InputGroup.Text onClick={clickHandler}>
          {" "}
          <FontAwesomeIcon icon={showPass ? faEyeSlash : faEye} />
        </InputGroup.Text>
      </InputGroup> */}

      <Form.Group>
        <Button
          type="submit"
          color="primary"
          className="mt-3 w-100"
          // disabled={!formData.email || !formData.password || !captcha}
          disabled={
            !formData.firstName ||
            !formData.emailAddress ||
            !formData.mobileNumber ||
            loading
          }
          onClick={handleSubmit}
        >
          {loading ? "Signing Up..." : "Sign Up"}
        </Button>
      </Form.Group>

      {/* <Divider className="mt-4">or log in with</Divider> */}

      {/* <SocialAuthButtons /> */}
    </Form>
  );
};

export default RegistrationForm;
